import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { beforeItems, afterItems } from '../data/content';
export function BeforeAfter() {
  return <section className="bg-white px-5 py-16 md:py-24" aria-labelledby="ba-title" data-id="element-40" data-mp="3ogauvp93qz4s">
      <div className="mx-auto max-w-6xl" data-id="element-41" data-mp="3sh344ihz5412">
        <div className="mx-auto max-w-3xl text-center" data-id="element-42" data-mp="3sg1qq7dhk5g6">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-brandDark" data-id="element-43" data-mp="3eq84lwtd7za5">
            From Clinical Uncertainty to a More Structured TRT Workflow
          </p>
          <h2 id="ba-title" className="mt-3 font-display text-3xl font-black leading-tight text-ink md:text-5xl" data-id="element-44" data-mp="3jirhsso54sef">
            You Don’t Need More Scattered Information. You Need a Clearer Way to Organize It.
          </h2>
          <div className="mt-5 space-y-3 text-lg leading-relaxed text-slate-600" data-id="element-45" data-mp="2vrcaelhibkwb">
            <p data-id="element-46" data-mp="2vtgdj17l0fvj">If you’ve ever found yourself reviewing multiple sources before making a TRT-related clinical decision, you already understand the problem.</p>
            <p className="font-semibold text-ink" data-id="element-47" data-mp="x38z6yapumen">The challenge isn’t necessarily a lack of medical knowledge.</p>
            <p data-id="element-48" data-mp="t2fesewhfpqi">It’s having the right information organized in a way that makes it easier to review the relevant considerations, identify what needs further evaluation, and determine the appropriate next step.</p>
          </div>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-49" data-mp="edsxw8r7ipx6">
          <div className="rounded-3xl border-2 border-red-200 bg-red-50 p-6 md:p-8" data-id="element-50" data-mp="eec813am8a0n">
            <h3 className="flex items-center gap-3 font-display text-2xl font-black text-red-700" data-id="element-51" data-mp="9gkek4ubofuc">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-alert text-white" data-id="element-52" data-mp="o5ghxolfp4om">
                <XIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-53" data-mp="jbud2ilii53d" />
              </span>
              Before TRT Blueprint
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-54" data-mp="3munqmveaitxj">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-red-950" data-id="element-55" data-mp="1qr997s64y6ht">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-56" data-mp="1vpkjg40cej0k" />
                  <span data-id="element-57" data-mp="20g0y1rfwgaoi">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-green-300 bg-green-50 p-6 md:p-8" data-id="element-58" data-mp="24idzw4rizog0">
            <h3 className="flex items-center gap-3 font-display text-2xl font-black text-green-700" data-id="element-59" data-mp="17seswer0wxzj">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-cta text-white" data-id="element-60" data-mp="1cqgcd0sd2zbj">
                <CheckIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-61" data-mp="1gsa7yunp9d4u" />
              </span>
              With TRT Blueprint
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-62" data-mp="1lpjy6ciwxstq">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-green-950" data-id="element-63" data-mp="2s7gojwkkuhk0">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-64" data-mp="2x4ytlbvh4cmq" />
                  <span data-id="element-65" data-mp="37cuqhdm6tcul">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-xl font-bold leading-snug text-ink md:text-2xl" data-id="element-66" data-mp="2xkx9fq8hzqny">
          The goal isn’t to replace your clinical judgment. It’s to help you organize the information that supports it.
        </p>

        <SectionCTA label="I Want a More Structured TRT Workflow" data-id="element-67" data-mp="2oltpyl5f598x" />
      </div>
    </section>;
}